// 审批流logo
export const logos = [
  'icon-diannao',
  'icon-gongfu',
  'icon-daka',
  'icon-dizhi1',
  'icon-danju',
  'icon-chucha',
  'icon-hongbao',
  'icon-huiyuan',
  'icon-gongwenbao',
  'icon-gouwu',
  'icon-jiaban3',
  'icon-jiaban',
  'icon-gongzizhengming',
  'icon-kuaidiche',
  'icon-jiabanche',
  'icon-gouwuche',
  'icon-jiaban2',
  'icon-qianbao',
  'icon-morentubiao',
  'icon-qian',
  'icon-jiayou',
  'icon-liwu',
  'icon-lizhi',
  'icon-lvhang',
  'icon-biaoqian',
  'icon-gongdan',
  'icon-shebeixiuli',
  'icon-tongjishuju',
  'icon-qingjia',
  'icon-shouji',
  'icon-tanhua',
  'icon-ruzhi',
  'icon-shijian',
  'icon-tupian1  ',
  'icon-waichu  ',
  'icon-tongyong',
  'icon-qiehuan',
  'icon-xiaoxi',
  'icon-gongzitiao',
  'icon-youhuiquan',
  'icon-yibiao',
  'icon-yonghugongxiang',
  'icon-yinhangka',
  'icon-kefu',
  'icon-yongren',
  'icon-youxiang',
  'icon-zaizhizhengming',
  'icon-zhuanzheng',
  'icon-zhuanfa',
  'icon-ziliao1',
  'icon-yuangong',
  'icon-wangdian',
  'icon-logo',
  'icon-ziliao2'
]

export const logoBgColors = ['#6691F7', '#EA6D74', '#F19851', '#7A6ECD', '#56B887', '#DA5BAA', '#B05FE1']
